import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { Card } from '../components/common';

const RefundCancellationPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-md shadow-soft sticky top-0 z-50 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link to="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-primary-600 transition-colors">
            <FiArrowLeft className="w-5 h-5" />
            <span className="font-medium">Back to Home</span>
          </Link>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <Card className="p-6 sm:p-8 lg:p-10 border-0 shadow-soft">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">Refund and Cancellation Policy</h1>
          
          <div className="prose prose-sm sm:prose-base max-w-none text-gray-700">
            <p className="text-lg">Refund will be processed within 7 days.</p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default RefundCancellationPolicy;


